import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { CardContent, Card, Typography } from "@mui/material";
import { AlertModal } from "@packsize/components";
import { FormattedMessage, useIntl } from "react-intl";

export interface NotificationBannerTemplateProps {
	readonly currentUrl: string;
	readonly onDismiss: () => void;
}

export const NotificationBannerTemplate = ({ currentUrl, onDismiss }: NotificationBannerTemplateProps) => {
	const intl = useIntl();

	return (
		<AlertModal
			open
			title={<FormattedMessage id="Bookmark Update Needed" defaultMessage="Bookmark Update Needed" />}
			Icon={WarningAmberIcon}
			confirmText={intl.formatMessage({ id: "Got it", defaultMessage: "Got it" })}
			onClose={onDismiss}
			onConfirm={onDismiss}
			slotProps={{
				icon: {
					sx: {
						color: "warning.main",
					},
				},
				confirmButton: {
					"data-pendoid": "notification-banner__button__got-it",
				},
			}}
			size="sm"
		>
			<Typography sx={{ mb: 2 }}>
				<FormattedMessage
					id="You accessed this page using an outdated URL. Please update your bookmark to use the current URL below:"
					defaultMessage="You accessed this page using an outdated URL. Please update your bookmark to use the current URL below:"
				/>
			</Typography>

			<Card>
				<CardContent>
					<Typography variant="caption" sx={{ fontFamily: '"Courier New", monospace' }}>
						{currentUrl}
					</Typography>
				</CardContent>
			</Card>
		</AlertModal>
	);
};
